<style lang="scss" src='./StarsRaiting.scss' scoped></style>
<template src="./StarsRaiting.html"></template>

<script>
  export default {
    name: 'StarsRaiting',
    name: 'Rating',
    props: {
      grade: {
        type: Number,
        default: 5,
      },
      maxStars: {
        type: Number,
        default: 5,
      },
      small: {
        type: Boolean,
        default: false,
      },
      hasCounter: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        stars: this.grade
      }
    },
    methods: {
      rate(star) {
        if (typeof star === 'number' && star <= this.maxStars && star >= 0 && !this.disabled) {
          this.stars = this.stars === star ? star - 1 : star
          this.$emit('change', this.stars)
        }
      }
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
  }

</script>
